/* eslint-disable jira/filename-case */
import type { PreloadedQuery } from 'react-relay';
import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import ServiceDeskPortalSettingsRelayQuery, {
	type ServiceDeskPortalSettingsQuery,
} from './__generated__/ServiceDeskPortalSettingsQuery.graphql.ts';

export const serviceDeskPortalSettingsResource: RouteResource<
	PreloadedQuery<ServiceDeskPortalSettingsQuery, Record<string, unknown>>
> = createRelayResource<ServiceDeskPortalSettingsQuery>({
	type: `${RELAY_RESOURCE_TYPE}_SERVICE_DESK_PORTAL_SETTINGS`,
	getQuery: (_, { tenantContext: { cloudId } }) => ({
		parameters: ServiceDeskPortalSettingsRelayQuery,
		variables: { cloudIdString: cloudId, cloudId },
		options: { fetchPolicy: 'store-and-network' },
	}),
	isCritical: true,
});
